/* eslint-disable no-param-reassign */

import IdleJs from "idle-js";
import {
  IDLE_TIME,
  VIDEO_PLAYING_GLOBAL_EVENT_NAME,
} from "@/util/constants.ts";

const moduleName = "idleVue";
const events = [
  "keydown",
  "mousedown",
  "touchstart",
  "mousemove",
  VIDEO_PLAYING_GLOBAL_EVENT_NAME,
];
const keepTracking = true;
const startAtIdle = false;

function createIdle(store) {
  const idle = new IdleJs({
    idle: IDLE_TIME,
    events,
    keepTracking,
    startAtIdle,

    onIdle() {
      store.commit(`${moduleName}/IDLE_CHANGED`, true);
    },
    onActive() {
      store.commit(`${moduleName}/IDLE_CHANGED`, false);
    },
  });

  idle.start();
}

const idleVue = {
  namespaced: true,
  state: {
    isIdle: startAtIdle,
  },
  mutations: {
    IDLE_CHANGED(state, isIdle) {
      state.isIdle = isIdle;
    },
  },
  getters: {
    isAppIdle(state) {
      return state.isIdle;
    },
  },
};

export { createIdle, idleVue };
